import lodash from 'lodash'
import config from './default'

let envConfig = {}

try {
  const env = process.env.NODE_ENV

  switch (env) {
    case 'development':
      envConfig = require('./dev').default
      break
    case 'test':
      envConfig = require('./test').default
      break
    case 'production':
      envConfig = require('./prod').default
      break
    default:
      envConfig = require('./dev').default
  }
} catch (o_o) {
  console.warn('used default config now')
}

lodash.merge(config, envConfig)

export default config